import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  DoCheck,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { AbstractControl, FormControl } from "@angular/forms";
import { G_PREFIX } from "../constants";
import { UpdateHostClassService } from "../services/update-host-class.service";

import { map } from "rxjs/operators";
import { noWhitespaceValidator } from "../utils/no-white-space-validators";
import { CommasDirective } from "../directives/commas/commas.directive";

// tslint:disable-next-line:no-conflicting-lifecycle
@Component({
  selector: "g-input, [g-input]",
  template: `<div
  class="g-input"
  (click)="!disabled && !readonly && focusInput()"
  g-outside
  (clickOutside)="blurInput()"
  [class.focused]="focused && !readonly"
  [class.active]="control.value || input?.nativeElement.value"
  [class.disabled]="disabled"
  [class.readonly]="readonly"
  [class.invalid]="control.invalid && control.touched"
  #el
>
  <div class="g-input-form-field">
    <label
      g-typography
      [type]="
        focused || control.value || input?.nativeElement.value
          ? 'small'
          : 'subHeadline'
      "
      >{{ placeholder }}
      <ng-container *ngIf="required"
        ><span class="required">*</span></ng-container
      ></label
    >
    <ng-container *ngIf="type !== 'textarea'; else textarea">
      <ng-container *ngIf="datepicker">
        <input
          type="text"
          #input
          (focus)="focusInput()"
          (blur)="blurInput()"
          [attr.disabled]="disabled || readonly ? true : null"
          [formControl]="control"
          [matDatepicker]="datepicker ? picker : null"
        />
      </ng-container>
      <ng-container *ngIf="!datepicker">
        <input
          type="text"
          #input
          (focus)="focusInput()"
          (blur)="blurInput()"
          [attr.disabled]="disabled || readonly ? true : null"
          [formControl]="control"
          [gNumber]="isNumber"
          [isTaxCode]="isTaxCode"
          [hasCommas]="!!withCommas"
        />
      </ng-container>
    </ng-container>
    <ng-template #textarea>
      <textarea
        #input
        (focus)="focusInput()"
        (blur)="blurInput()"
        [attr.disabled]="disabled || readonly ? true : null"
        [formControl]="control"
        [gNumber]="isNumber"
      ></textarea>
    </ng-template>

    <div
      class="g-input-reset"
      *ngIf="clearButton && !disabled && !readonly && focused && control.value"
      (click)="control.reset()"
    >
      <mat-icon>close</mat-icon>
    </div>
  </div>
  <div
    class="g-input-prefix"
    #prefix
    (click)="datepicker && !readonly && !disabled ? picker.open() : null"
  >
    <ng-content select="g-prefix"></ng-content>
  </div>
</div>

<mat-datepicker #picker></mat-datepicker>
`,
  styles: [`.g-menu-item{display:flex;position:relative;align-items:center;justify-content:flex-start;overflow:hidden;padding:0 16px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:0;border:none;-webkit-tap-highlight-color:transparent;cursor:pointer;width:100%;text-align:left;box-sizing:border-box;color:inherit;font-size:inherit;background:0 0;text-decoration:none;margin:0;min-height:48px}.g-menu-item:hover:not([disabled]){background:rgba(0,0,0,.04)}.g-menu-item[disabled]{cursor:default;opacity:.38}.g-placeholder{display:inline-block;min-height:1em;vertical-align:middle;cursor:wait;width:100%;background-color:var(--color-grey-500);opacity:.5}.g-placeholder.btn::before{display:inline-block;content:""}.g-placeholder-small{min-height:16px}.g-placeholder-standard{min-height:24px}.g-placeholder-glow .g-placeholder{-webkit-animation:2s ease-in-out infinite placeholder-glow;animation:2s ease-in-out infinite placeholder-glow}@-webkit-keyframes placeholder-glow{50%{opacity:.2}}@keyframes placeholder-glow{50%{opacity:.2}}.g-placeholder-wave{-webkit-mask-image:linear-gradient(130deg,#000 25%,rgba(0,0,0,.8) 75%,#000 55%);mask-image:linear-gradient(130deg,#000 25%,rgba(0,0,0,.8) 75%,#000 55%);-webkit-mask-size:200% 100%;mask-size:200% 100%;-webkit-animation:2s linear infinite placeholder-wave;animation:2s linear infinite placeholder-wave}@-webkit-keyframes placeholder-wave{100%{-webkit-mask-position:-200% 0;mask-position:-200% 0}}@keyframes placeholder-wave{100%{-webkit-mask-position:-200% 0;mask-position:-200% 0}}b,b.g-typography,strong,strong.g-typography{font-weight:600}a,a.g-typography{color:var(--color-darkBlue-500);text-decoration:none}.g-typography--large{margin-bottom:.5em;font-size:2.125rem;line-height:1.4;font-weight:700}.g-typography--title1,h1,h1.g-typography--title{margin-bottom:.5em;font-size:1.75rem;line-height:1.4;font-weight:700}.g-typography--title2,h2,h2.g-typography--title{margin-bottom:.5em;font-size:1.375rem;line-height:1.4;font-weight:700}.g-typography--title3,h3,h3.g-typography--title{margin-bottom:.5em;font-size:1.25rem;line-height:1.4;font-weight:600}.g-typography--body{margin-bottom:.5em;font-size:1rem;line-height:1.4;font-weight:400}.g-typography--headline{margin-bottom:.5em;font-size:1.0625rem;line-height:1.4;font-weight:600}.g-typography--subHeadline{margin-bottom:.5em;font-size:.9375rem;line-height:1.4;font-weight:400}.g-typography--small{margin-bottom:.5em;font-size:.8125rem;line-height:1.4;font-weight:400}.g-typography--caption{margin-bottom:.5em;font-size:.75rem;line-height:1.4;font-weight:400}.g-input{height:60px;padding:0 16px;min-width:108px;background:#fff;position:relative}.g-input--textarea{height:100px}.g-input-form-field{padding-top:24px;padding-bottom:10px;position:relative;height:100%}.g-input-form-field label{position:absolute;top:28px;-webkit-transform:translateY(-50%);transform:translateY(-50%);color:var(--color-grey-500);transition:.4s;margin-bottom:0}.g-input-form-field input,.g-input-form-field textarea{border:none;padding:0;width:100%;height:100%;outline:0;resize:none;font-family:inherit;font-size:.9375rem;line-height:1.4;font-weight:600;margin:0}.g-input-form-field .required{color:var(--color-red-500)}.g-input-form-field textarea{padding:5px 0}.g-input.invalid{border-color:var(--color-red-500)}.g-input.active label,.g-input.focused label{top:18px}.g-input input,.g-input textarea{background:0 0}.g-input.disabled{background:#f9f9f9}.g-input.disabled input{pointer-events:none}.g-input.readonly input,.g-input.readonly textarea{color:var(--color-grey-600);pointer-events:none}.g-input.readonly .g-input-prefix{opacity:.5}.g-input--fill{box-shadow:0 1.00267px 0 #e6e6e6;transition:.4s}.g-input--fill.focused{box-shadow:0 1.00267px 0 var(--color-primary)}.g-input--outline{border:1px solid;border-color:var(--color-grey-200)}.g-input--outline.focused{border-color:var(--color-primary)}.g-input .g-input-prefix{position:absolute;top:30px;-webkit-transform:translateY(-50%);transform:translateY(-50%);max-width:25px;display:inline-block}.g-input .g-input-prefix ::ng-deep img{max-width:25px}.g-input--prefix-left{padding-left:50px}.g-input--prefix-left .g-input-prefix{left:25px;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.g-input--prefix-right{padding-right:50px}.g-input--prefix-right .g-input-prefix{right:25px;-webkit-transform:translate(50%,-50%);transform:translate(50%,-50%)}.g-input--rounded{border-radius:12px}.g-input--clear.g-input-form-field{padding-right:25px}.g-input .g-input-reset{position:absolute;right:0;top:30px;-webkit-transform:translateY(-50%);transform:translateY(-50%);display:inline-flex;cursor:pointer}.g-input .g-input-reset mat-icon{font-size:16px;height:16px;width:16px;line-height:16px}`],
  providers: [UpdateHostClassService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputComponent
  implements OnInit, AfterViewInit, DoCheck, OnChanges
{
  @ViewChild("input", { static: false }) input: ElementRef;
  @ViewChild("el", { static: true }) el: ElementRef;
  @ViewChild("prefix", { static: true }) prefix: ElementRef;
  @ViewChild(CommasDirective, { static: false }) commas: CommasDirective;

  @Input() required: boolean;
  @Input() type: "input" | "textarea" = "input";
  @Input() appearance: "fill" | "outline" = "fill";
  @Input() rounded = true;
  @Input() placeholder: string;
  @Input() disabled: boolean;
  @Input() readonly: boolean;
  @Input() clearButton: boolean;
  @Input() prefixPosition: "right" | "left" = "left";
  @Input() value = null;
  @Input() control: AbstractControl = new FormControl(null);
  @Input() datepicker = false;
  @Input() isNumber = false;
  @Input() withCommas = "";
  @Input() isTaxCode = false;
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onChange = new EventEmitter<any>();
  @Output() focusChange = new EventEmitter<boolean>();

  focused = false;
  constructor(
    private _updateHostClassService: UpdateHostClassService,
    private _cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.control.valueChanges
      .pipe(
        map((value) => {
          this.onChange.emit(value);
          this._cdr.detectChanges();
        })
      )
      .subscribe();
  }

  private updateClass(): void {
    const prefixCls = G_PREFIX + "-input";
    this._updateHostClassService.updateHostClass(this.el.nativeElement, {
      [`${prefixCls}--${this.type}`]: this.type,
      [`${prefixCls}--${this.appearance}`]: this.appearance,
      [`${prefixCls}--rounded`]: this.rounded,
      [`${prefixCls}--clear`]: this.clearButton,
      [`${prefixCls}--prefix`]: this.prefix.nativeElement.childNodes.length,
      [`${prefixCls}--prefix-${this.prefixPosition}`]:
        this.prefix.nativeElement.childNodes.length && this.prefixPosition,
    });
  }

  dateChange(event) {}

  ngOnChanges(changes: SimpleChanges): void {
    const { value, isNumber, withCommas } = changes;
    if (value) {
      this.control.setValue(value.currentValue);
    }
  }

  focusInput() {
    this.focused = true;
    this.focusChange.emit(true);
    this.input.nativeElement.focus();
  }

  blurInput() {
    if (this.focused) {
      setTimeout(() => {
        this.focusChange.emit(false);
      }, 100);
    }
    this.focused = false;
  }

  ngAfterViewInit(): void {
    this.updateClass();
    // this.control.setValidators(noWhitespaceValidator);
    // if (this.isNumber && this.withCommas && this.commas) {
    //   if (this.control.value) {
    //     this.commas.onInputChange(this.control.value);
    //   }
    //   if (this.value) {
    //     this.commas.onInputChange(this.value);
    //   }
    // }
    this._cdr.detectChanges();
  }

  ngDoCheck() {
    if (this.control && this.control.touched) {
      this._cdr.detectChanges();
    }
  }
}
